<template lang="pug">
    include ../../media/pug/mixins
    +b.SECTION.document-view
        template(v-if="!isMobile")
            +e.HEADER.header
                +e.BUTTON.btn.btn_icon
                    v-icon(name="star")
                +e.SPAN.title(v-html="documentTitle")
                +e.SPAN.link.link_dashed(v-on:click="openModal") {{ $t('DESCRIPTION') }}
            +e.zooming-btns(v-bind:class="{'document-view__zooming-btns_dark' : marks.isOverlayVisible}")
                +e.BUTTON.zoom-btn_plus.btn(
                    v-on:click="$zoom.in"
                    type="button"
                )
                +e.BUTTON.zoom-btn.btn(
                    v-on:click="$zoom.out"
                    type="button"
                )
        +e.display
            +e.container(v-bar="true")
                +e.scroll-container(
                    v-dragscroll:nochilddrag="!getTextPageCurrentFlag"
                    ref="scrollContainer"
                )
                    document-view-img(
                        v-bind:is-overlay-visible.sync='marks.isOverlayVisible'
                        v-bind:is-all-marks-visible.sync="marks.isAllVisible"
                        v-bind:viewer-height="viewerHeight"
                        v-bind:viewer-width="viewerWidth"
                    )

</template>

<script>
import { mapGetters } from 'vuex';
import RslLoader from '@RSL/RslLoader/RslLoader';
import Hammer from 'hammerjs';
import DocumentViewImg from '@/components/document-views/DocumentViewImg';
import zoom from '@/helpers/mixins/zoom';
import documentView from '@/helpers/mixins/document-view';

export default {
    components: {
        RslLoader,
        DocumentViewImg
    },
    mixins: [zoom, documentView],
    data() {
        return {
            scrollContainer: null,
            badgeOffset: 20,
            startMove: {
                top: 0,
                left: 0
            },
            img: {
                x: 0,
                y: 0
            },
            newZoomFinger: 0,
            isNotPanMove: true,
            viewerHeight: 0,
            viewerWidth: 0,
            marks: {
                isOverlayVisible: false,
                isAllVisible: false
            }
        };
    },
    computed: {
        ...mapGetters([
            'getMainImageParams',
            'getIsOnePage',
            'getGeneralInfo',
            'getDocInfo',
            'isMobile',
            'isTablet',
            'isDesktop',
            'getZoom',
            'getMainImgZoomWidth',
            'getTextPageCurrentFlag',
            'getCurrentSidebarTab',
            'isMenuPanelVisible',
            'isMarkConfirmVisible',
            'isMarkEditorVisible',
            'isAddMarkMode',
            'getMarks',
            'getAreas',
            'isMarkEditMode'
        ]),
        mobInterfaceHeight() {
            return [this.isMarkEditorVisible, this.isMenuPanelVisible];
        },
        documentTitle() {
            return `<b>${this.getDocInfo.authorInfo}</b> ${this.getDocInfo.cardTitle.split(' : ')[0]}`;
        },
        marksBtnClass() {
            return {
                'document-view__marks-btn_opened': this.marks.isAllVisible,
                'document-view__marks-btn_hidden': this.isAddMarkMode
            };
        },
        marksCounter() {
            return this.getMarks.length + this.getAreas.length;
        }
    },
    watch: {
        mobInterfaceHeight(val) {
            const [editor, nav] = val;
            let editorHeight = 0;
            let navHeight = 0;
            const gutter = 20;
            this.$nextTick(() => {
                if (editor && nav) {
                    editorHeight = document.querySelector('.mark-editor').clientHeight;
                    navHeight = document.querySelector('.menu-panel__section_navigation').clientHeight;
                    this.badgeOffset = editorHeight + navHeight + gutter;
                } else if (editor) {
                    editorHeight = document.querySelector('.mark-editor').clientHeight;
                    this.badgeOffset = editorHeight + gutter;
                } else if (nav) {
                    navHeight = document.querySelector('.menu-panel__section_navigation').clientHeight;
                    this.badgeOffset = navHeight + gutter;
                } else {
                    this.badgeOffset = gutter;
                }
            });
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        // здесь на срабатывание должно быть условие с апи, что пользователь вошел первый раз
        // чтобы оно не мешало каждый раз условием показа будет тестовый id 01000185404
        if (this.$route.params.id === '01000185404') {
            this.$store.dispatch('showModal', 'ModalDocInfo');
        }
    },
    mounted() {
        this.setViewerParams();
        if (!this.isDesktop) {
            this.initTouchEvents();
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        initTouchEvents() {
            this.scrollContainer = this.$refs.scrollContainer;
            this.$nextTick(() => {
                const manager = new Hammer.Manager(this.scrollContainer);
                manager.add(new Hammer.Tap());
                manager.add(new Hammer.Pinch());
                manager.add(new Hammer.Pan());
                if (this.isMobile) manager.on('tap', this.toggleMobileNavigation);
                manager.on('panstart', this.fingerMoveStart);
                manager.on('panend', this.fingerMoveEnd);
                manager.on('pinchmove', this.zoomFingers);
                manager.on('pinchstart', this.zoomFingersStart);
                manager.on('panmove', this.fingerMove);
            });
        },
        openModal() {
            this.$store.dispatch('showModal', 'RslCardItem');
        },
        isContainer(target) {
            return target instanceof HTMLImageElement
                   || target === document.querySelector('.document-view-img__overlay');
        },
        fingerMove(e) {
            if (this.isContainer(e.target) && !this.isAddMarkMode) {
                this.scrollContainer.scrollLeft = this.startMove.left + -e.deltaX;
                this.scrollContainer.scrollTop = this.startMove.top + -e.deltaY;
            }
        },
        fingerMoveStart() {
            if (this.isContainer) {
                this.isNotPanMove = false;
                this.startMove = {
                    top: this.scrollContainer.scrollTop,
                    left: this.scrollContainer.scrollLeft
                };
            }
        },
        fingerMoveEnd(e) {
            // page turn for touch devices and not for infinite mode
            if (this.isContainer(e.target) && !this.isAddMarkMode) {
                if (!this.isNotPanMove && !this.getIsOnePage) {
                    let horizontal = false;
                    const { scrollContainer } = this;
                    let newPage = +this.$route.query.page;
                    if (e.additionalEvent === 'panright' || e.additionalEvent === 'panleft') {
                        horizontal = true;
                    }
                    if (horizontal) {
                        if ((this.getTextPageCurrentFlag
                            || this.startMove.left === 0)
                            && e.deltaX > 0) {
                            if (newPage > 1) {
                                newPage -= 1;
                            }
                        } else if (
                            (this.getTextPageCurrentFlag
                            || this.startMove.left
                            + scrollContainer.offsetWidth >= Math.floor(this.getMainImgZoomWidth))
                            && e.deltaX < 0) {
                            if (newPage < this.getGeneralInfo.maxPages) {
                                newPage += 1;
                            }
                        }
                    }
                    const { rotate, negative } = this.$route.query;
                    this.$router.push({
                        query: {
                            page: newPage,
                            rotate,
                            negative
                        }
                    });
                }
            }
        },
        zoomFingers(e) {
            const { scrollContainer } = this;
            const screenImageRatio = scrollContainer.offsetWidth / this.getMainImageParams.width;
            if (
                this.newZoomFinger * e.scale > screenImageRatio
                && this.newZoomFinger * e.scale < 3) {
                this.$store.commit('SET_NEW_ZOOM', this.newZoomFinger * e.scale);
                scrollContainer.scrollLeft = this.img.x * e.scale - e.center.x;
                scrollContainer.scrollTop = this.img.y * e.scale - e.center.y;
            }
        },
        zoomFingersStart(e) {
            const { scrollContainer } = this;
            if (!this.getTextPageCurrentFlag) {
                this.img.x = scrollContainer.scrollLeft + e.center.x;
                this.img.y = scrollContainer.scrollTop + e.center.y;
                this.isNotPanMove = true;
                this.startMove = {
                    top: scrollContainer.scrollTop,
                    left: scrollContainer.scrollLeft
                };
            }
            this.newZoomFinger = this.getZoom;
        },
        toggleMobileNavigation(e) {
            if (this.isContainer(e.target) && !this.isAddMarkMode && !this.isMarkEditMode) {
                this.$store.commit('SET_MENU_PANEL_VISIBILITY', !this.isMenuPanelVisible);
            }
        },
        setViewerParams() {
            this.viewerHeight = this.$documentView.calcHeight();
            this.viewerWidth = this.$documentView.calcWidth();
        },
        handleResize() {
            this.containerSizeMath();
            this.setViewerParams();
            if (this.isMobile && this.getIsOnePage) {
                this.$store.commit('SET_ONE_PAGE_STATE', false);
            }
        },
        containerSizeMath() {
            if (this.isDesktop) {
                this.$documentView.setFullHeight();
            } else {
                this.$documentView.setFullWidth();
            }
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/document-views/document-view.sass"></style>
